import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";
import { LEGAL_NOTICE_LINE_HEIGHT } from "src/components/LegalNotice/styles";

export const TosSubheader = () => {
  const theme = useTheme();

  return (
    <Stack>
      <Typography
        variant="body2"
        textAlign="center"
        component="p"
        color={theme.palette.text.secondary}
        lineHeight={LEGAL_NOTICE_LINE_HEIGHT}
      >
        These terms and conditions (these &ldquo;Terms&rdquo;) constitute a
        binding legal agreement between each individual, entity, group or
        association who views, interacts, links to or otherwise uses or derives
        any benefit from Terminal (as defined below) (&ldquo;Users&rdquo;) and
        Inspired Acquisitions, Ltd., and its affiliates, officers, directors,
        employees, contractors, assigns, agents and subsidiaries (the
        owner/operator of Terminal) (collectively, with its successors and
        assigns, the &ldquo;Site Operator&rdquo;).
      </Typography>
      <Typography
        variant="body2"
        textAlign="center"
        component="p"
        color={theme.palette.text.secondary}
        sx={{ mt: 2 }}
        lineHeight={LEGAL_NOTICE_LINE_HEIGHT}
      >
        Please contact us at{" "}
        <Box component="span" sx={{ color: "primary.main" }}>
          notices@padre.gg
        </Box>{" "}
        for any technical questions, issues or legal issues/notices.
      </Typography>
    </Stack>
  );
};
